import { watch } from "vue"; 
import { useAppStore } from "@/stores/AppStore";
import { useRouter } from "vue-router"; //< TODO ... move all navigation here ...

import Events from "@/services/Emitter";

const ns = {};

// TODO - MOVE ALL REUSABLE CODE HERE ... ALERTS / NOTIFY / CACHE / ACCOUNT / ETC ...

// >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
// private inner members of the module ...

const inner = {};
inner.router = null;

ns.initialize = async () =>
{
    // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
    // initialize all app stores ...
    
    const appStore = useAppStore();

    // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
    // initialize the logged in user ...

    appStore.getAccount();


    // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
    // notify all listeners that the app is initialized ...

    Events.emit("initialized", ns);

};

//#region NAVIGATION

ns.registerRouter = (router) =>
{
    inner.router = router;
};

ns.go = (url) =>
{

};

ns.back = () =>
{

};

//#endregion

//#region USER



//#endregion

export default ns;